/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from 'react'
import { RenderContextProvider, Renderer } from '@contensis/canvas-react'
import { EmphasisAl, StrongAl } from '~/components/Canvas/decorators'
import {
  MyFragment,
  // MyHeading,
  // MyImage,
  MyLink,
  // MyList,
  // MyListItem,
  MyParagraph,
  MyTable
} from '~/components/Canvas/blocks'

const TableColourContext = createContext<any | undefined>(undefined)
export const useLayoutItems = () => useContext(TableColourContext)

type BlockData = {
  canvas: any
}

const Tables = ({
  content,
  layoutColour
}: {
  content: BlockData
  layoutColour?: string
}) => {
  const layoutItems = {
    layoutColour: layoutColour || 'default'
  }

  const { canvas } = content

  if (!canvas) {
    return null
  }

  return (
    <TableColourContext.Provider value={layoutItems}>
      <RenderContextProvider
        blocks={{
          _paragraph: MyParagraph,
          _table: MyTable,
          _link: MyLink,
          _fragment: MyFragment
        }}
        // components={{}}
        decorators={{
          strong: StrongAl,
          emphasis: EmphasisAl
        }}
      >
        <Renderer data={canvas} />
      </RenderContextProvider>
    </TableColourContext.Provider>
  )
}

export default Tables
